<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="cms-list">
    <data-table :service="VoucherService"
                :entity="entity"
                :filters="filters"
                :columns="columns"
                :disable-permission-checks="true"
                ref="table">
    </data-table>
  </div>
</template>
<script>
  import Badge from 'src/components/Badge'
  import VoucherService from 'src/services/VoucherService';
  import entities from 'src/config/entities';

  export default {
    name: 'voucher-list',
    components: {
      Badge
    },
    data() {
      return {
        VoucherService,
        entity: entities.VOUCHER
      }
    },
    computed: {
      filters() {
        return []
      },
      columns() {
        return [
          {
            prop: "code",
            label: this.$t('vouchers.form.code'),
          },
          {
            prop: "discount_type",
            label: this.$t('vouchers.form.discount_type'),
          },
          {
            prop: "discount_value",
            label: this.$t('vouchers.form.discount_value'),
          },
          {
            prop: "usage_limit",
            label: this.$t('vouchers.form.usage_limit'),
          },
          {
            prop: "usage_count",
            label: this.$t('vouchers.form.usage_count'),
          },
          {
            prop: "expires_at",
            label: this.$t('vouchers.form.expires_at'),
          },
        ]
      }
    }
  }
</script>
<style lang="scss" scoped>
  .post-image {
    min-width: 144px;
  }
  .segments__container {
    overflow-x: auto;
    display: flex;
  }
</style>
